import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { marked } from 'marked';

import { apiClient } from '@services/apiClient';

export interface IHelperAiActiveChatResponse {
  id: string;
  chatId: string;
  userId: number;
  customerId: number;
  expiredAt: string;
  messages: [
    {
      id: number;
      content: string;
      chatId: string;
      role: string;
    },
  ];
  success?: boolean;
}

export const helperAiActiveChatKey = () => ['helperAiActiveChat'];

export const helperAiActiveChatFn = () => {
  return apiClient.get(`${APP_API_URL_V2}ai-helper/chats/active`);
};

const helperAiActiveChatSelect = ({ data }: AxiosResponse<{ data: IHelperAiActiveChatResponse }>) => {
  if (data.data.id) {
    const activeChat = { ...data.data };

    const formattedMessages = activeChat.messages.map((message) => ({
      ...message,
      content: marked.parse(message.content),
    }));

    //@ts-ignore formattedMessages has type 'string | Promise<string>
    activeChat.messages = formattedMessages;

    return activeChat;
  }

  return data.data || {};
};

export const useHelperAiActiveChatQuery = (props: {
  onSuccess: (data: IHelperAiActiveChatResponse) => void;
}) => {
  return useQuery({
    queryKey: helperAiActiveChatKey(),
    queryFn: helperAiActiveChatFn,
    select: helperAiActiveChatSelect,
    onSuccess: (data) => props?.onSuccess && props.onSuccess(data),
  });
};
